// Unpublished Work © 2021-2024 Deere & Company.

export const AVAILABLE = 'Available';
export const CONNECTED = 'Connected';
export const INVALID = 'Invalid';
